#import "@/components/common/LinkFragment.gql"

fragment StoryCategoryBlockFragment on storyCategoryBlock_Entry {
  typeHandle
  heading
  stories: storiesPageBlocksStories {
    ... on storiesPageBlocksStoriesBlock_Entry {
      image {
        url
        title
      }
      story {
        ...LinkFragment
      }
    }
  }
}
